<template>
    <div class="counter__cont">
        <ul class="counter__row">
            <li class="hour">{{ timeLeftMinutes }}:{{ timeLeftSecond }}</li>
            <li>{{ countAnswered }}<small>問</small> / 15<small>問</small></li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "Counter",
    props:[ 'countAnswered', 'timeLeftMinutes', 'timeLeftSecond' ]
}
</script>

<style scoped>

</style>
